import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { message } from 'antd';
import classNames from 'classnames';
import styles from './WallpaperOpt.module.less';
import { useHistory, useLocation } from 'react-router-dom';
import { logging } from '../../actions/log';
import { myWallpaper } from '../../constants/storageKeys';
import { PCStoreJsBridge } from '../../nativeapi';
import {
  updatePreviewInfo,
  addDownloadImg,
  operationImg,
  updateShowWpOrder,
  updateShowWpTurnStop,
  showBatchAddInfo,
} from '../../actions/wallpaper';
import success from '../../static/msg-success.svg';
import fail from '../../static/msg-fail.svg';
import useLoginStatus, { handleLogin } from '../../utils/hooks/useLoginStatus';
import { WP_PRODUCT_BUY_STATUS_80 } from '../../config';
import { createAxios, localSetItem, localGetItem } from '../../utils/utils';
import { logNative } from '../../utils/utils';
import WpProductDetail from '../WallpaperCard/WpProductDetail';
import WpProductDownload from '../WallpaperCard/WpProductDownloadBtn';
import WpTurnBtn from '../WallpaperCard/WpTurnBtn';
import Toast from '../Toast/Toast';
import { createShortcut } from '../../actions/layout';
import config from '../../pages/Wallpaper/config';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectWpOpteration = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpOpteration,
);
const selectWpPreview = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpPreviewInfo,
);

const SelectWpBatchInfoShow = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpBatchInfoShow,
);
export default memo(({ wallpaper, cardInfo, logInfo, handleCallback = () => {} }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  // 处理收藏删除结果
  const wpOpteration = useSelector(selectWpOpteration);
  // 全屏预览壁纸
  const wpPreview = useSelector(selectWpPreview);
  const [isRedCollect, setIsRedCollect] = useState(false);
  const [isBusyingCollect, setIsBusyingCollect] = useState(false);
  const [isBusyingWallpaper, setIsBusyingWallpaper] = useState(false);
  const [isBusyingPreview, setIsBusyingPreview] = useState(false);
  const [isBusyingDelete, setIsBusyingDelete] = useState(false);
  const [isBusyingDeleteTurn, setIsBusyingDeleteTurn] = useState(false);
  const [isBusyingHidden, setIsBusyingHidden] = useState(false);
  const loginStatus = useLoginStatus();
  const [wpProduct, setWpProduct] = useState({ hasBuy: false, show: false, hasSetPath: true });
  const [wpTask, setWpTask] = useState({});
  const location = useLocation();
  const wpBatchInfoShow = useSelector(SelectWpBatchInfoShow); // 批量添加按钮是否展开

  const failToast = useCallback(content => {
    Toast.error({
      content: '操作失败，请重试！',
    });
  }, []);

  const getBuyStatus = useCallback(async () => {
    let hasbuy = null;
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(WP_PRODUCT_BUY_STATUS_80, {
        params: {
          type: 1,
          skuId: wallpaper?.wallpaperId,
        },
      });
      if (res?.data?.status == 0) {
        setWpProduct(state => ({
          ...state,
          hasBuy: true,
        }));
        hasbuy = 1;
      } else if (res?.data?.status == -1) {
        hasbuy = -1;
      }
    } catch (err) {
      failToast();
      logNative(`请求壁纸${wallpaper?.wallpaperId} 错误${err}`);
    }
    return hasbuy;
  }, [wallpaper]);

  // 登录状态发生变化，点赞收藏状态发生变化
  useEffect(() => {
    setWpProduct(state => ({
      ...state,
      hasBuy: false,
    }));
  }, [loginStatus]);

  useEffect(() => {
    if (loginStatus) {
      if (wpTask.collect) {
        handleCollect(wallpaper);
      } else if (wpTask.setWp) {
        handleSetWallpaper(wallpaper);
      }
    }
  }, [loginStatus, wpTask, wallpaper]);

  /**
   * 初始化心
   */
  useEffect(() => {
    const wpCollStr = sessionStorage.getItem('wallpaper_collect') || '[]';
    if (wallpaper?.hasCollect !== 0 || wpCollStr.indexOf(wallpaper?.wallpaperId) > -1) {
      setIsRedCollect(true);
    } else {
      setIsRedCollect(false);
    }
  }, []);

  const addSessionStorageCollectWp = useCallback(wp => {
    try {
      const wpCollStr = sessionStorage.getItem('wallpaper_collect') || '';
      let wpColl = wpCollStr.split(',');
      if (wpColl.indexOf(wp.wallpaperId) === -1) {
        wpColl.push(wp.wallpaperId);
        sessionStorage.setItem('wallpaper_collect', wpColl.join(','));
      }
    } catch (error) {}
  });
  const delSessionStorageCollectWp = useCallback(wp => {
    try {
      const wpCollStr = sessionStorage.getItem('wallpaper_collect') || '';
      let wpColl = wpCollStr.split(',');
      if (wpColl.indexOf(wp.wallpaperId) > -1) {
        wpColl.splice(wpColl.indexOf(wp.wallpaperId), 1);
      }

      sessionStorage.setItem('wallpaper_collect', wpColl.join(','));
    } catch (error) {}
  });

  const updateSessionStorageCollectWp = useCallback(wp => {
    try {
      const wpCollStr = sessionStorage.getItem('wallpaper_collect') || '[]';
      const wpColl = wpCollStr.split(',');
      sessionStorage.setItem('wallpaper_collect', [...wpColl, wp.wallpaperId].join(','));
    } catch (error) {}
  });

  /**
   * 操作结束处理
   * type: 1-收藏 （点赞）2-收藏列表中删除（即取消点赞）3-设为壁纸 4-从曾用壁纸中删除
   */
  useEffect(() => {
    if (
      wallpaper?.wallpaperId &&
      wpOpteration?.wallpaperId &&
      wpOpteration.wallpaperId === wallpaper.wallpaperId
    ) {
      if (wpOpteration.status === 0) {
        // 点赞成功的处理
        if (wpOpteration.type === 1) {
          setIsRedCollect(true);
          addSessionStorageCollectWp(wallpaper);
        }
        if (wpOpteration.type === 2) {
          delSessionStorageCollectWp(wallpaper);
        }
        // 点赞删除、曾用中删除 成功的处理
        if (wpOpteration.type === 2 || wpOpteration.type === 4) {
          if (cardInfo.deleteCallback) {
            cardInfo.deleteCallback({
              wallpaperId: wpOpteration.wallpaperId,
              type: wpOpteration.type,
            });
          }
        }
      } else {
        if (wpOpteration.type === 1) {
          setIsRedCollect(false);
          setIsBusyingCollect(false);
        }
        failToast();
      }
    }
  }, [wpOpteration]);

  const updateOptState = useCallback(() => {
    setTimeout(() => {
      setIsBusyingCollect(false);
      setIsBusyingWallpaper(false);
      setIsBusyingPreview(false);
      setIsBusyingDelete(false);
      setIsBusyingDeleteTurn(false);
      setIsBusyingHidden(false);
    }, 100);
  }, []);

  /**
   * 点击收藏
   */
  const handleCollect = useCallback(
    wp => {
      // 未登录 直接截断弹出登录
      if (!loginStatus) {
        handleLogin();
        setWpTask(state => ({ ...state, collect: true }));
        return;
      }
      if (wpBatchInfoShow) {
        dispatch(showBatchAddInfo(false));
      }
      if (isRedCollect) {
        message.error({
          content: '已赞过该壁纸',
          icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        });
        return;
      }
      if (isBusyingCollect) {
        return;
      }
      // 外部页面用于打桩使用
      handleCallback &&
        handleCallback({
          actionType: 'C_Wallpaper_Collect',
          wallpaperId: wallpaper.wallpaperId,
          authorId: wallpaper.author && wallpaper.author.authorId,
        });
      setIsRedCollect(true);
      setIsBusyingCollect(true);
      //取消排队任务
      setWpTask(state => ({ ...state, collect: false }));
      // 1-收藏 （点赞）2-收藏列表中删除（即取消点赞）3-设为壁纸 4-从曾用壁纸中删除
      if (wpOpteration && wpOpteration.load === false) {
        dispatch(operationImg({ type: 1, wallpaperId: wp.wallpaperId }));
        setIsRedCollect(true);
      }
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'C_Wallpaper_Collect',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            wallpaperId: wallpaper.wallpaperId,
            authorId: wallpaper.author && wallpaper.author.authorId,
            search_type:
              cardInfo?.pageSource === 'Search_Wallpaper' ||
              cardInfo?.pageSource === 'Search_Wallpaper_Reco'
                ? logInfoData.search_type
                : '',
            search_word:
              cardInfo?.pageSource === 'Search_Wallpaper' ||
              cardInfo?.pageSource === 'Search_Wallpaper_Reco'
                ? logInfoData.search_word
                : '',
          },
          param3: wallpaper?.bizInfo || '{}',
        }),
      );
    },
    [
      dispatch,
      logInfoData,
      wallpaper,
      wpOpteration,
      isRedCollect,
      isBusyingCollect,
      loginStatus,
      wpBatchInfoShow,
    ],
  );

  /**
   * 取消收藏
   */
  const handleDelete = useCallback(
    wp => {
      if (isBusyingDelete) {
        return;
      }
      if (wpBatchInfoShow) {
        dispatch(showBatchAddInfo(false));
      }
      setIsBusyingDelete(true);
      updateOptState();
      // 1-收藏 （点赞）2-收藏列表中删除（即取消点赞）3-设为壁纸 4-从曾用壁纸中删除
      if (wpOpteration.load === false) {
        const type = (cardInfo.isDeleteColl && 2) || (cardInfo.isDeleteUsed && 4);
        dispatch(operationImg({ type, wallpaperId: wp.wallpaperId }));
        dispatch(
          logging({
            category: 'Wallpaper',
            action: type === 2 ? `C_Wallpaper_Delete_Collect` : 'C_Wallpaper_Delete_Used',
            label: '',
            param2: {
              source: logInfo.source,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              wallpaperId: wallpaper.wallpaperId,
              authorId: wallpaper.author && wallpaper.author.authorId,
              search_type:
                cardInfo?.pageSource === 'Search_Wallpaper' ||
                cardInfo?.pageSource === 'Search_Wallpaper_Reco'
                  ? logInfoData.search_type
                  : '',
              search_word:
                cardInfo?.pageSource === 'Search_Wallpaper' ||
                cardInfo?.pageSource === 'Search_Wallpaper_Reco'
                  ? logInfoData.search_word
                  : '',
            },
            param3: wallpaper?.bizInfo || '{}',
          }),
        );
        handleCallback &&
          handleCallback({
            actionType: type === 2 ? `C_Wallpaper_Delete_Collect` : 'C_Wallpaper_Delete_Used',
            wallpaperId: wallpaper.wallpaperId,
            authorId: wallpaper.author && wallpaper.author.authorId,
          });
      }
    },
    [dispatch, logInfoData, wallpaper, wpOpteration, isBusyingDelete, wpBatchInfoShow],
  );

  const delSessionStorageTurnWp = useCallback(wp => {
    if (!wp?.wallpaperId) {
      return;
    }
    let turnList_add = JSON.parse(sessionStorage.getItem('Wp_Turn_List_Add') || '[]');
    let turnList_del = JSON.parse(sessionStorage.getItem('Wp_Turn_List_Del') || '[]');
    turnList_add = turnList_add.filter(item => item !== wp?.wallpaperId);
    turnList_del = turnList_del.filter(item => item !== wp?.wallpaperId);
    sessionStorage.setItem('Wp_Turn_List_Add', JSON.stringify([...turnList_add]));
    sessionStorage.setItem('Wp_Turn_List_Del', JSON.stringify([...turnList_del, wp?.wallpaperId]));
  }, []);

  // 移除壁纸轮播
  const handleDeleteTurn = useCallback(
    async wp => {
      if (isBusyingDeleteTurn) {
        return;
      }
      if (wpBatchInfoShow) {
        dispatch(showBatchAddInfo(false));
      }
      setIsBusyingDeleteTurn(true);
      updateOptState();
      if (wp?.wallpaperId || wp?.contentId) {
        try {
          // 处理轮播壁纸的删除参数
          let param = { contentId: wp.wallpaperId, groupType: '1' };
          // 处理轮播壁纸组的删除参数
          if (wp?.groupType && wp?.groupType !== '1') {
            param = { contentId: wp.contentId, groupType: wp.groupType };
          }

          let res = await config.delWpToTurn({ ...param });
          if (res?.status === 0) {
            Toast.success({
              content: '从壁纸轮播列表中删除成功',
            });
            if (cardInfo?.deleteTurnCallback) {
              cardInfo.deleteTurnCallback({ ...wp });
            }
            delSessionStorageTurnWp(wp);
          }

          // dispatch(
          //   logging({
          //     category: 'Wallpaper',
          //     action: 'C_Wallpaper_LoopCancel_Mine',
          //     label: '',
          //     param2: {
          //       source: logInfoData?.source,
          //       source_p: logInfoData?.source_p,
          //       source_pp: logInfoData?.source_pp,
          //       groupType: wp?.groupType || '1', // 1:单张壁纸；2：分类；3:曾用；4：收藏
          //       wallpaperId: wp?.wallpaperId,
          //       contentId: wp.contentId,
          //     },
          //   }),
          // );
        } catch {}
      }
    },
    [isBusyingDeleteTurn, cardInfo, wpBatchInfoShow],
  );

  const setWallpaper = useCallback(
    param => {
      // 直接设置壁纸
      PCStoreJsBridge.wpSetWallpaper(param).then(ret2 => {
        if (ret2.succ === 'true') {
          message.success({
            content: '壁纸设置成功，请查看电脑桌面',
            className: wpPreview && wpPreview.isShow ? 'ant-message-notice-center' : '',
            icon: <img className="ant-message-custom-img" src={success} alt="success" />,
            // onClose: () => {
            //   // 判断是否是有快捷方式
            //   let localPath = location.pathname;
            //   if (
            //     (localPath.indexOf('/wprecommend') > -1 ||
            //       localPath.indexOf('/wpmine/setup') > -1 ||
            //       localPath.indexOf('/wpcategory') > -1 ||
            //       localPath.indexOf('/wpdetail') > -1 ||
            //       localPath.indexOf('/wprank') > -1 ||
            //       localPath.indexOf('/wpauthordetail') > -1 ||
            //       localPath.indexOf('/wphot') > -1 ||
            //       localPath.indexOf('/wprankpage') > -1) &&
            //     !wpPreview.isShow
            //   ) {
            //     PCStoreJsBridge.checkWALLPAPERxits().then(res => {
            //       if (res.PIN) {
            //         if (!localGetItem('FIRST_WALLPAPER')) {
            //           dispatch(
            //             createShortcut({
            //               tag: true,
            //               loginInfo: logInfo,
            //               wallpaperInfo: wallpaper,
            //             }),
            //           );
            //         }
            //       }
            //     });
            //   } else {
            //     localSetItem('FIRST_WALLPAPER', true);
            //   }
            // },
          });
          window.wpSettingWallpaperTaskList = window.wpSettingWallpaperTaskList.filter(
            item => param.id !== item.id,
          );
          // 去关闭轮播
          PCStoreJsBridge.switchWpOpenTurn({
            switch: 'off',
          }).then(res => {
            if (res) {
              if (
                window.PCStore_WpMine_TurnUpdate &&
                typeof window.PCStore_WpMine_TurnUpdate === 'function'
              ) {
                setTimeout(() => {
                  window.PCStore_WpMine_TurnUpdate();
                }, 100);
              }
              dispatch(
                logging({
                  category: 'Wallpaper',
                  action: 'R_Wallpaper_Loop_Stop',
                  label: '',
                  param2: {
                    source: logInfoData?.source,
                    source_p: logInfoData?.source_p,
                    source_pp: logInfoData?.source_pp,
                    Looptype: 2,
                  },
                }),
              );
            }
          });
        } else {
          failToast();
        }
      });
    },
    [wpPreview, location],
  );

  const testUrl = useCallback(wp => {
    if (!wp || !wp.wallpaperImg || !wp.wallpaperImg[2] || !wp.wallpaperImg[2].uri) {
      message.error({
        content: '壁纸不存在',
        icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
      });
      return false;
    }
    return true;
  }, []);

  const callbackTurnOrder = useCallback(
    async flag => {
      if (flag) {
        handleSetWallpaper(wallpaper);
      }
    },
    [dispatch, logInfoData, wallpaper, wpOpteration, isBusyingWallpaper, loginStatus],
  );

  const callbackTurnStop = useCallback(
    async flag => {
      if (flag) {
        handleSetWallpaper(wallpaper);
      }
    },
    [dispatch, logInfoData, wallpaper, wpOpteration, isBusyingWallpaper, loginStatus],
  );

  const handleSetWallpaper = useCallback(
    async wp => {
      // 判断是否登录
      if (!loginStatus) {
        handleLogin();
        setWpTask(state => ({ state, setWp: true }));
        return;
      }
      if (wpBatchInfoShow) {
        dispatch(showBatchAddInfo(false));
      }
      // 是否正在轮播中。
      let switchTurn = {};
      if (window?.external?.get_wallpaper_carousel_switch_info) {
        switchTurn = JSON.parse(window.external.get_wallpaper_carousel_switch_info() || '{}');
      }
      let isSwitchTurnShow = localStorage.getItem('Wp_Switch_Turn_Show');

      // 如果轮播开启，并且没有弹出过提示弹框，则弹出
      if (switchTurn?.switch === 'on' && !isSwitchTurnShow) {
        dispatch(
          updateShowWpTurnStop({
            show: true,
            wallpaper: wallpaper,
            cardInfo: cardInfo,
            logInfo: logInfo,
            callbackTurnStop: callbackTurnStop,
          }),
        );
        updateOptState();
        return;
      }

      // 判断是否付费
      if (wp?.pay === 1) {
        // 付费壁纸
        const hasBuy = await getBuyStatus('set');
        if (hasBuy === -1) {
          dispatch(
            updateShowWpOrder({
              show: true,
              wallpaperId: wallpaper?.wallpaperId,
              code: '',
              wpType: wallpaper.type || 1, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
              scenetype: 'set', // 'set', 'dl', 'resident', 'loop_single', 'loop_batch', 'loop_start'
              wallpaper: wallpaper,
              cardInfo: cardInfo,
              logInfo: logInfo,
              callbackTurnOrder: callbackTurnOrder,
            }),
          );
          updateOptState();
          return;
        } else if (hasBuy === 1) {
          //  触发发下载
        } else {
          failToast();
          return;
        }
      }

      if (isBusyingWallpaper || !testUrl(wp)) {
        return;
      }

      handleCallback &&
        handleCallback({
          actionType: 'C_Wallpaper_Setting',
          wallpaperId: wallpaper.wallpaperId,
          authorId: wallpaper.author && wallpaper.author.authorId,
        });
      setIsBusyingWallpaper(true);
      updateOptState();

      //取消排队任务
      setWpTask(state => ({ ...state, setWp: false }));
      // 1-收藏 （点赞）2-收藏列表中删除（即取消点赞）3-设为壁纸 4-从曾用壁纸中删除
      if (wpOpteration && wpOpteration.load === false) {
        dispatch(operationImg({ type: 3, wallpaperId: wp.wallpaperId }));
      }
      const param = { url: wp.wallpaperImg[2].uri, id: wp.wallpaperId };
      // 判断是否下载图片
      PCStoreJsBridge.wpIsDownloadedImg(param).then(ret => {
        if (ret.succ === 'true') {
          // 同时正在设置壁纸中的任务控制在三个以内
          if (!window.wpSettingWallpaperTaskList) {
            window.wpSettingWallpaperTaskList = [param];
            setWallpaper(param);
          } else if (
            window.wpSettingWallpaperTaskList &&
            window.wpSettingWallpaperTaskList.length < 3
          ) {
            const found = window.wpSettingWallpaperTaskList.find(wp => wp.id === param.id);
            if (!found) {
              window.wpSettingWallpaperTaskList.push(param);
              setWallpaper(param);
            }
          } else {
            failToast();
          }
        } else {
          // 请求下载图片
          PCStoreJsBridge.wpDownloadImg({
            id: wp.wallpaperId,
            url: wp.wallpaperImg[2].uri,
            type: 'setWallpaper',
            code: logInfo.source,
            bizinfo: wp.bizInfo || '{}',
          }).then(ret2 => {
            if (ret2.succ === 'true') {
              dispatch(addDownloadImg({ wallpaper: { ...wp, type: 'setWallpaper' } }));
            } else {
              failToast();
            }
          });
        }
      });

      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'C_Wallpaper_Setting',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            wallpaperId: wp.wallpaperId,
            authorId: wallpaper.author && wallpaper.author.authorId,
            search_type:
              cardInfo?.pageSource === 'Search_Wallpaper' ||
              cardInfo?.pageSource === 'Search_Wallpaper_Reco'
                ? logInfoData.search_type
                : '',
            search_word:
              cardInfo?.pageSource === 'Search_Wallpaper' ||
              cardInfo?.pageSource === 'Search_Wallpaper_Reco'
                ? logInfoData.search_word
                : '',
          },
          param3: wallpaper?.bizInfo || '{}',
        }),
      );
    },
    [
      dispatch,
      logInfoData,
      wallpaper,
      wpOpteration,
      isBusyingWallpaper,
      loginStatus,
      wpBatchInfoShow,
    ],
  );

  /**
   * 产品需求，最小化的时候点击预览，退出预览图片要定位到之前的位置
   * 验证是否为最小化的时候点击了预览，然后获取到页面滚动div和滚动高度存在redux的wpPreview中
   * 退出预览后一段时间，将页面滚动到此位置
   */
  const checkIsNeedSaveScrollTop = target => {
    if (document.body.clientWidth === 1060 && document.body.clientHeight === 680) {
      let dom = target;
      while (
        dom &&
        dom?.parentNode &&
        dom?.id !== 'root' &&
        (!dom?.className || (dom?.className && dom?.className?.indexOf('page--') === -1))
      ) {
        dom = dom?.parentNode || null;
      }
      if (dom && dom.scrollTop && dom?.className?.indexOf('page--') > -1) {
        return {
          scrollDom: dom,
          scrollTop: dom.scrollTop,
        };
      }
    }
    return null;
  };

  // 预览
  const handleSetPreview = useCallback(
    (e, wp) => {
      if (isBusyingPreview || !testUrl(wp)) {
        return;
      }
      handleCallback &&
        handleCallback({
          actionType: 'C_Wallpaper_Preview',
          wallpaperId: wallpaper.wallpaperId,
          authorId: wallpaper.author && wallpaper.author.authorId,
        });
      setIsBusyingPreview(true);
      updateOptState();
      if (wpBatchInfoShow) {
        dispatch(showBatchAddInfo(false));
      }
      let scrollObj = checkIsNeedSaveScrollTop(e.target);
      dispatch(
        updatePreviewInfo({
          isShow: false,
          wallpaperId: wp.wallpaperId,
          scrollObj: scrollObj,
        }),
      );

      // 判断是否下载图片
      PCStoreJsBridge.wpIsDownloadedImg({ url: wp.wallpaperImg[2].uri, id: wp.wallpaperId }).then(
        ret => {
          if (ret.succ === 'true') {
            // 设置窗口大小，并且显示预览的图片
            PCStoreJsBridge.wpMaximizeStroe().then(ret2 => {
              if (ret2.succ) {
                dispatch(
                  updatePreviewInfo({
                    isShow: true,
                    wallpaperId: wp.wallpaperId,
                    url: ret.msg,
                    wallpaper: wp,
                    scrollObj: scrollObj,
                  }),
                );
              } else {
                failToast();
              }
            });
          } else {
            // 请求下载图片
            PCStoreJsBridge.wpDownloadImg({
              id: wp.wallpaperId,
              url: wp.wallpaperImg[2].uri,
              type: 'setPreview',
              code: logInfo.source,
              bizinfo: wp.bizInfo || '{}',
            }).then(ret2 => {
              if (ret2.succ === 'true') {
                dispatch(addDownloadImg({ wallpaper: { ...wp, type: 'setPreview' } }));
              } else {
                failToast();
              }
            });
          }
        },
        () => {
          failToast();
        },
      );
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'C_Wallpaper_Preview',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            wallpaperId: wallpaper.wallpaperId,
            authorId: wallpaper.author && wallpaper.author.authorId,
            search_type:
              cardInfo?.pageSource === 'Search_Wallpaper' ||
              cardInfo?.pageSource === 'Search_Wallpaper_Reco'
                ? logInfoData.search_type
                : '',
            search_word:
              cardInfo?.pageSource === 'Search_Wallpaper' ||
              cardInfo?.pageSource === 'Search_Wallpaper_Reco'
                ? logInfoData.search_word
                : '',
          },
          param3: wallpaper?.bizInfo || '{}',
        }),
      );
    },
    [dispatch, logInfoData, wallpaper, isBusyingPreview, wpBatchInfoShow],
  );

  // 取消预览
  const handleWpPreviewHidden = useCallback(() => {
    if (isBusyingHidden) {
      return;
    }
    handleCallback &&
      handleCallback({
        actionType: 'C_Wallpaper_Preview_Out',
        wallpaperId: wallpaper.wallpaperId,
        authorId: wallpaper.author && wallpaper.author.authorId,
      });
    setIsBusyingHidden(true);
    updateOptState();
    if (wpBatchInfoShow) {
      dispatch(showBatchAddInfo(false));
    }
    let type = sessionStorage.getItem('PCStoreIsMaximize');
    if (type !== '1') {
      PCStoreJsBridge.wpExitMaximizeStroe().then(
        ret => {
          if (ret.succ) {
            if (wpPreview?.scrollObj?.scrollDom && wpPreview?.scrollObj?.scrollTop) {
              setTimeout(() => {
                wpPreview.scrollObj.scrollDom.scrollTop = wpPreview?.scrollObj?.scrollTop;
              }, 20);
            }
            dispatch(updatePreviewInfo(null));
          } else {
            failToast();
          }
        },
        () => {
          failToast();
        },
      );
    } else {
      dispatch(updatePreviewInfo(null));
    }

    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'C_Wallpaper_Preview_Out',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          wallpaperId: wallpaper.wallpaperId,
          authorId: wallpaper.author && wallpaper.author.authorId,
          search_type:
            cardInfo?.pageSource === 'Search_Wallpaper' ||
            cardInfo?.pageSource === 'Search_Wallpaper_Reco'
              ? logInfoData.search_type
              : '',
          search_word:
            cardInfo?.pageSource === 'Search_Wallpaper' ||
            cardInfo?.pageSource === 'Search_Wallpaper_Reco'
              ? logInfoData.search_word
              : '',
        },
        param3: wallpaper?.bizInfo || '{}',
      }),
    );
  }, [dispatch, logInfoData, wallpaper, isBusyingHidden, wpPreview, wpBatchInfoShow]);

  return (
    <>
      <div className={cardInfo.isBig ? styles.wpopt_big : styles.wpopt}>
        {cardInfo.isShowTurn && (
          <WpTurnBtn
            wallpaper={wallpaper}
            cardInfo={cardInfo}
            logInfo={logInfo}
            classType={{ type: 'wp_big', name: 'wpimg_downbtn_mid' }}
          />
        )}
        {cardInfo.isShowDown && wallpaper?.hasDownloadButton === 1 && (
          <div className={styles.down}>
            <WpProductDownload
              wallpaper={{ ...wallpaper, type: 1 }}
              size="big"
              callback={() => {
                // handleWpPreviewHidden(wallpaper);
                handleCallback();
              }}
            />
          </div>
        )}
        {cardInfo.isCollect && (
          <div
            className={classNames('box box1', { isRedCollect: loginStatus && isRedCollect })}
            onClick={e => {
              e.stopPropagation();
              handleCollect(wallpaper);
            }}
            title="收藏 "
          >
            <div className="icon default" />
            <div className="icon hover" />
            <div className="heart" />
            <div className="circle" />
          </div>
        )}
        {cardInfo.isWallpaper && (
          <div
            className="opt_wallpaper"
            onClick={e => {
              e.stopPropagation();
              handleSetWallpaper(wallpaper);
            }}
            title="设为壁纸 "
          />
        )}
        {cardInfo.isPreview && (
          <div
            className="opt_preview"
            onClick={e => {
              e.stopPropagation();
              handleSetPreview(e, wallpaper);
            }}
            title="预览 "
          />
        )}
        {(cardInfo.isDeleteColl || cardInfo.isDeleteUsed) && (
          <div
            className="opt_delete"
            onClick={e => {
              e.stopPropagation();
              handleDelete(wallpaper);
            }}
            title="删除收藏 "
          />
        )}
        {cardInfo.isDeleteTurn && (
          <div
            className="opt_delete"
            onClick={e => {
              e.stopPropagation();
              handleDeleteTurn(wallpaper);
            }}
            title="删除轮播 "
          />
        )}
        {cardInfo.isPreviewOut && (
          <div
            className="opt_previeweout"
            onClick={e => {
              e.stopPropagation();
              handleWpPreviewHidden(wallpaper);
            }}
            title="收起 "
          />
        )}
      </div>
      {/* {wpProduct?.show && (
          <WpProductDetail
            wallpaper={{ ...wallpaper }}
            handleClose={() => {
              setWpProduct({ ...wpProduct, show: false });
            }}
            errMsg="操作失败，请重试！"
          />
        )} */}
    </>
  );
});
